import React, { Component, Fragment } from 'react';
import { message, Spin } from 'antd';
import './LZLuckyDrawPage.scss'
import Header from './components/Header.js'
import Rule from './components/Rule.js'
import Sudoku from './components/Sudoku';
import Dialog from './components/Dialog';
import UserInfoPanel from './components/UserInfoPanel';
import axios from 'axios';
import qs from 'qs';
import { callNative } from '../utils/LZTools';

const baseUrl = "https://www.laizekeji.cn/api";

class LZLuckyDrawPage extends Component {
  constructor (props) {
    super(props);
    
    this.state = {
      loading: true,
      showDialog: false,
      prizeDetail: {},
      prizeList: [],
      userInfo: {},
      err: '',
      logo: '',
      rule: ''
    }

    this.closeDialog = this.closeDialog.bind(this);
    this.showDialog = this.showDialog.bind(this);
    this.updateUserInfo = this.updateUserInfo.bind(this);
    this.clickedRulePanelButton = this.clickedRulePanelButton.bind(this);

    window.showDialog = this.showDialog;
    window.updateUserInfo = this.updateUserInfo;
  }

  componentDidMount () {
    this.getData();
  }
  
  getData () {
    //获取用户详情
    callNative({
      "type":"request",
      "data":{
        "reqUrl":"/api/v1/user/fetchLuckyDrawInfo",
        "callBackFunc":"updateUserInfo",
        "params":{},
      }
    });

    const _this = this;

    this.setState({
      loading: true,
    });

    axios.post(baseUrl+'/v1/luckyDraw/getPrizeList')
      .then(function (res) {
        console.log(res);
        let data = res.data || {};
        _this.setState({
          loading: false,
          prizeList: data.data || [],
        });
      })
      .catch(function (error){
        _this.setState({
          loading: false,
          err: error || '网络出错',
        });
        message.error('网络出错');
      });
  }

  showDialog(params) {
    setTimeout(() => {
      if (!params || params == undefined) {
        message.info("网络请求错误", 1);
        
        if (this.sudoku && this.sudoku != undefined) {
          this.sudoku.stopRolling();
        }
        return;
      }
      
      this.setState({
        showDialog: true,
        prizeDetail: params,
      }, ()=>{
        if (this.sudoku && this.sudoku != undefined) {
          this.sudoku.stopRolling();
        }
      });
    }, 1000);
  }

  closeDialog() {
    this.setState({
      showDialog: false,
    });
  }

  updateUserInfo(params) {
    if (!params || params == undefined) {
      message.info("网络请求错误", 1);
      return;
    }

    let tempUserInfo = params || {};

    this.setState({
      userInfo: tempUserInfo
    });

    if (this.sudoku && this.sudoku != undefined) {
      this.sudoku.updateDrawTimes(tempUserInfo.drawTimes || 0);
    }
  }

  clickedRulePanelButton() {
    this.showDialog({
      isWinner: true,
      prizeDetail: {}
    });
  }

  render () {
    const { loading, err, prizeList, userInfo, showDialog, prizeDetail } = this.state;

    let con;
    if (loading) {
      con = (
        <Spin tip="加载中" style={{marginTop:'50vh'}} size="large" >
          <div className="content" />
        </Spin>
      );
    }

    if (err) {
      con = <div className="err">{err}</div>;
    }

    if (!loading && !err) {
      con = (
        <>
          { 
            showDialog ? (
              <Dialog 
                closeDialog={this.closeDialog} 
                prizeDetail={prizeDetail}
              />
            ) : <div/> 
          }
          <div className='bgView' />
          <div className="luckyDrawWrap">
            <Header />
            <Sudoku 
              prizeList = {prizeList}
              drawTimes = {userInfo.drawTimes}
              ref={(ref)=>{
                this.sudoku = ref;
              }}
            />
            <Rule />
            <UserInfoPanel 
              loginTimes={userInfo.loginTimes}
              sumPrice={userInfo.sumPrice}
              didClickedShareBtn={()=>{
                callNative({
                  "type":"jump",
                  "data":{
                    "des":"LZSharePanel",
                    "params":{},
                  }
                });
              }}
            />
          </div>
        </>
      )
    }

    return (
      <>
        { con }
      </>
    );
  }
  
}

export default LZLuckyDrawPage;
